module.exports = __webpack_public_path__ + "img/axle_conf_13.573cf95a.jpg";